export default __webpack_public_path__ + "static/media/background-bottom-right-illustration.3be108cf.svg";